var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-data d-flex align-center justify-center",class:{ small: _vm.small, medium: _vm.medium }},[_c('div',{staticClass:"text-center"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }